import styles from './reset.module.css';
import FullSize from '../../components/full-size';
import { useEffect } from 'react';

function Reset() {

  useEffect(() => {
    localStorage.removeItem("LEVELS_COMPLETED");
  }, [])

  return (
    <FullSize bgColor="teal">
      <div className={styles.reset_wrapper}>
        <h1 className={styles.title}>Restart.</h1>
        <p className={styles.text}>Allt har nollställts.</p>
      </div>
    </FullSize>
  );
}

export default Reset;
